import React, { Fragment, useState } from 'react';
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import EmployeeInfo from './EmployeeInfo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  formatPhoneNumber,
  formatSSN,
  unformatPhoneNumber,
  unformatSSN,
} from '../Utils/formatters';

const NewEmployeeInfo = (props) => {
  const [showSSN, setShowSSN] = useState(false);

  const toggleSSN = () => {
    setShowSSN(!showSSN);
  };

  return (
    <Fragment>
      <fieldset>
        <legend>Employee Information</legend>
        <div
          className={
            props.errMsg &&
            props.getFieldError &&
            props.getFieldError('hireType')
              ? 'hireStatus error'
              : 'hireStatus'
          }
        >
          <label className="required">Hire status</label>
          <div>
            <label htmlFor="hireStatus">Hire:</label>
            <input
              type="radio"
              required
              name="hireType"
              id="hireStatus"
              checked={props.newHireInfo.hireType === 'newhire'}
              value="newhire"
              onChange={(e) => props.onHandleChange(e)}
            />
            <label htmlFor="reHireStatus">Rehire:</label>
            <input
              type="radio"
              required
              name="hireType"
              id="reHireStatus"
              checked={props.newHireInfo.hireType === 'rehire'}
              value="rehire"
              onChange={(e) => props.onHandleChange(e)}
            />
          </div>
          {props.errMsg &&
            props.getFieldError &&
            props.getFieldError('hireType') && (
              <span className="error-text">
                {props.getFieldError('hireType')}
              </span>
            )}
        </div>
        <EmployeeInfo
          checkInputValid={props.checkInputValid}
          payload={props.newHireInfo}
          changeEmpInfo={props.onHandleChange}
          getFieldError={props.getFieldError}
          errMsg={props.errMsg}
        />
        <div className="newhire-address-info">
          <div
            className={
              props.errMsg &&
              props.getFieldError &&
              props.getFieldError('employee.address.address1')
                ? 'address1 error'
                : 'address1'
            }
          >
            <label htmlFor="address1" className="required">
              Address:
            </label>
            <input
              type="text"
              id="address1"
              name="address1"
              value={props.newHireInfo.employee.address.address1}
              required
              onChange={(e) => props.handleAddressInfo(e)}
            />
            {props.errMsg &&
              props.getFieldError &&
              props.getFieldError('employee.address.address1') && (
                <span className="error-text">
                  {props.getFieldError('employee.address.address1')}
                </span>
              )}
          </div>
          <div className="address2">
            <label htmlFor="address2" className="required">
              Apt #:
            </label>
            <input
              type="text"
              id="address2"
              name="address2"
              value={props.newHireInfo.employee.address.address2}
              onChange={(e) => props.handleAddressInfo(e)}
            />
          </div>
          <div
            className={
              props.errMsg &&
              props.getFieldError &&
              props.getFieldError('employee.address.city')
                ? 'city error'
                : 'city'
            }
          >
            <label htmlFor="city" className="required">
              City:
            </label>
            <input
              type="text"
              name="city"
              id="city"
              value={props.newHireInfo.employee.address.city}
              required
              onChange={(e) => props.handleAddressInfo(e)}
            />
            {props.errMsg &&
              props.getFieldError &&
              props.getFieldError('employee.address.city') && (
                <span className="error-text">
                  {props.getFieldError('employee.address.city')}
                </span>
              )}
          </div>
          <div
            className={
              props.errMsg &&
              props.getFieldError &&
              props.getFieldError('employee.address.state')
                ? 'state error'
                : 'state'
            }
          >
            <label htmlFor="state" className="required">
              State:
            </label>
            <select
              onChange={(e) => props.handleAddressInfo(e)}
              value={props.newHireInfo.employee.address.state}
              required
              name="state"
              id="state"
            >
              <option key="startOption" value="" name="state">
                Select state
              </option>
              {props.states?.map((state, index) => {
                return (
                  <option
                    key={index}
                    value={state?.stateShortName}
                    name="state"
                  >
                    {state?.stateName}
                  </option>
                );
              })}
            </select>
            {props.errMsg &&
              props.getFieldError &&
              props.getFieldError('employee.address.state') && (
                <span className="error-text">
                  {props.getFieldError('employee.address.state')}
                </span>
              )}
          </div>
          <div
            className={
              props.errMsg &&
              props.getFieldError &&
              props.getFieldError('employee.address.zip')
                ? 'zip error'
                : 'zip'
            }
          >
            <label htmlFor="zip" className="required">
              Zip:
            </label>
            <input
              type="text"
              id="zip"
              name="zip"
              value={props.newHireInfo.employee.address.zip}
              required
              onChange={(e) => props.handleAddressInfo(e)}
            />
            {props.errMsg &&
              props.getFieldError &&
              props.getFieldError('employee.address.zip') && (
                <span className="error-text">
                  {props.getFieldError('employee.address.zip')}
                </span>
              )}
          </div>
        </div>
        <div
          className={
            props.errMsg &&
            props.getFieldError &&
            props.getFieldError('employee.phone1')
              ? 'phone1 error'
              : 'phone1'
          }
        >
          <label htmlFor="phone1" className="required">
            Phone
          </label>
          <input
            type="text"
            id="phone1"
            name="phone1"
            value={formatPhoneNumber(props.newHireInfo.employee.phone1)}
            maxLength={12}
            required
            onChange={(e) => {
              const unformatted = unformatPhoneNumber(e.target.value);
              e.target.value = unformatted;
              props.onHandleChange(e);
            }}
          />
          {props.errMsg &&
            props.getFieldError &&
            props.getFieldError('employee.phone1') && (
              <span className="error-text">
                {props.getFieldError('employee.phone1')}
              </span>
            )}
        </div>
        <div className="phone2">
          <label htmlFor="phone2">Alt. Phone</label>
          <input
            type="text"
            id="phone2"
            name="phone2"
            value={formatPhoneNumber(props.newHireInfo.employee.phone2)}
            maxLength={12}
            onChange={(e) => {
              const unformatted = unformatPhoneNumber(e.target.value);
              e.target.value = unformatted;
              props.onHandleChange(e);
            }}
          />
        </div>
        <div
          className={
            props.errMsg &&
            props.getFieldError &&
            props.getFieldError('employee.email')
              ? 'email error'
              : 'email'
          }
        >
          <label htmlFor="email">E-mail</label>
          <input
            type="text"
            id="email"
            name="email"
            value={props.newHireInfo.employee.email}
            autoComplete="true"
            onChange={(e) => props.onHandleChange(e)}
          />
          {props.errMsg &&
            props.getFieldError &&
            props.getFieldError('employee.email') && (
              <span className="error-text">
                {props.getFieldError('employee.email')}
              </span>
            )}
        </div>
        <div
          className={
            props.errMsg &&
            props.getFieldError &&
            props.getFieldError('employee.ssn')
              ? 'ssn error'
              : 'ssn'
          }
        >
          <label htmlFor="ssn" className="required">
            SSN
          </label>
          <div>
            <input
              type={showSSN ? 'text' : 'password'}
              id="ssn"
              name="ssn"
              value={
                showSSN
                  ? formatSSN(props.newHireInfo.employee.ssn)
                  : props.newHireInfo.employee.ssn
              }
              maxLength={showSSN ? 11 : 9}
              required
              onChange={(e) => {
                const unformatted = unformatSSN(e.target.value);
                e.target.value = unformatted;
                props.onHandleChange(e);
              }}
            />
            <FontAwesomeIcon
              icon={showSSN ? faEye : faEyeSlash}
              onClick={() => toggleSSN()}
            />
          </div>
          {props.errMsg &&
            props.getFieldError &&
            props.getFieldError('employee.ssn') && (
              <span className="error-text">
                {props.getFieldError('employee.ssn')}
              </span>
            )}
        </div>
        <div
          className={
            props.errMsg &&
            props.getFieldError &&
            props.getFieldError('employee.dob')
              ? 'content error'
              : 'content'
          }
        >
          <label htmlFor="dob" className="required">
            DOB:
          </label>
          <input
            type="date"
            id="dob"
            name="dob"
            value={props.newHireInfo.employee.dob}
            className="dob"
            title="Please enter the required information"
            required
            onChange={(e) => props.onHandleChange(e)}
          />
          {props.errMsg &&
            props.getFieldError &&
            props.getFieldError('employee.dob') && (
              <span className="error-text">
                {props.getFieldError('employee.dob')}
              </span>
            )}
        </div>
        <div
          className={
            props.errMsg &&
            props.getFieldError &&
            props.getFieldError('employee.gender')
              ? 'content error'
              : 'content'
          }
        >
          <label htmlFor="sex" className="required">
            Gender
          </label>
          <select
            id="sex"
            name="gender"
            value={props.newHireInfo.employee.gender}
            required
            className="sex"
            title="Please enter the required information"
            onChange={(e) => props.onHandleChange(e)}
          >
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Not_Identified">Identifies as another gender</option>
          </select>
          {props.errMsg &&
            props.getFieldError &&
            props.getFieldError('employee.gender') && (
              <span className="error-text">
                {props.getFieldError('employee.gender')}
              </span>
            )}
        </div>
      </fieldset>
    </Fragment>
  );
};

NewEmployeeInfo.propTypes = {};

export default NewEmployeeInfo;
